import { render, staticRenderFns } from "./EiCouponCreate.vue?vue&type=template&id=1ae25927&scoped=true&"
import script from "./EiCouponCreate.vue?vue&type=script&lang=js&"
export * from "./EiCouponCreate.vue?vue&type=script&lang=js&"
import style0 from "./EiCouponCreate.vue?vue&type=style&index=0&id=1ae25927&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae25927",
  null
  
)

component.options.__file = "EiCouponCreate.vue"
export default component.exports